export default "__VITE_ASSET__D540IS6$__"